import SiteLayout from "@/components/feature/SiteLayout";
import PageMeta from "@/components/base/PageMeta";
import { posts } from "@/mocks/posts";
import { topics } from "@/mocks/topics";
import { faqItems } from "@/mocks/faq";
import type { Post, Topic } from "@/types/content";
import Hero from "./components/Hero";
import TrendingList from "./components/TrendingList";
import HotPosts from "./components/HotPosts";
import CategoryGrid from "./components/CategoryGrid";
import DailyPick from "./components/DailyPick";
import CommunityStrip from "./components/CommunityStrip";
import FaqPreview from "./components/FaqPreview";

const allPosts = posts as Post[];
const allTopics = topics as Topic[];

const trending = [...allPosts].sort((a, b) => a.hot - b.hot).slice(0, 6);
const hotPosts = [...allPosts].sort((a, b) => b.likes - a.likes).slice(0, 6);
const picks = allPosts.filter((p) => p.featured).slice(0, 4);
const homeFaq = faqItems.slice(0, 4);

const jsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      name: "高校吃瓜网",
      url: "https://www.gaoxiaochigua.cn/",
      description:
        "高校吃瓜网聚合各高校热门帖子与讨论区动态，每日精选高赞吃瓜话题，一网打尽学生都在聊什么。",
      potentialAction: {
        "@type": "SearchAction",
        target: "https://www.gaoxiaochigua.cn/topics?q={search_term_string}",
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@type": "Organization",
      name: "高校吃瓜网",
      url: "https://www.gaoxiaochigua.cn/",
      email: "contact@gaoxiaochigua.cn",
      description: "面向在校学生的校园话题聚合与讨论社区。",
    },
    {
      "@type": "ItemList",
      name: "今日热搜榜",
      itemListElement: trending.map((post, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: post.title,
        url: `https://www.gaoxiaochigua.cn/post/${post.id}`,
      })),
    },
    {
      "@type": "FAQPage",
      mainEntity: homeFaq.map((item) => ({
        "@type": "Question",
        name: item.question,
        acceptedAnswer: { "@type": "Answer", text: item.answer },
      })),
    },
  ],
};

export default function Home() {
  return (
    <SiteLayout>
      <PageMeta
        title="高校吃瓜网 - 高校吃瓜论坛与社区，学生都在聊什么一网打尽"
        description="高校吃瓜网聚合各高校热门帖子与讨论区动态，每日精选高赞吃瓜话题，带你快速找到同校吃瓜现场，一网打尽学生都在聊什么。"
        keywords="高校吃瓜,高校吃瓜论坛,高校吃瓜社区,高校吃瓜讨论,高校吃瓜群"
        path="/"
      >
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </PageMeta>

      <Hero />
      <TrendingList items={trending} />
      <HotPosts items={hotPosts} />
      <CategoryGrid topics={allTopics} />
      <DailyPick items={picks} />
      <CommunityStrip />
      <FaqPreview items={homeFaq} />
    </SiteLayout>
  );
}